import React from 'react';
import Icon from '../../../components/AppIcon';
import { motion } from 'framer-motion';

const DisclaimerSection = ({ currentLanguage }) => {
  const content = {
    EN: {
      title: "Important Information",
      disclaimers: [
        {
          icon: "AlertTriangle",
          title: "Credit Reporting",
          text: "Activity may be reported to Equifax. Reporting is not guaranteed and results vary by individual."
        },
        {
          icon: "Info",
          title: "No Guaranteed Results", 
          text: "PSPXpress does not guarantee credit score improvement. Results depend on overall credit management and other factors."
        },
        {
          icon: "Shield",
          title: "Equifax Partnership",
          text: "PSPXpress works with Equifax® to help track your credit history. Equifax® is a registered trademark of Equifax Canada Co."
        }
      ]
    },
    FR: {
      title: "Informations importantes",
      disclaimers: [
        {
          icon: "AlertTriangle",
          title: "Rapport de crédit",
          text: "L'activité peut être signalée à Equifax. Le signalement n'est pas garanti et les résultats varient selon l'individu."
        },
        {
          icon: "Info",
          title: "Aucun résultat garanti",
          text: "PSPXpress ne garantit pas l\'amélioration du score de crédit. Les résultats dépendent de la gestion globale du crédit et d\'autres facteurs."
        },
        {
          icon: "Shield", 
          title: "Partenariat Equifax",
          text: "PSPXpress travaille avec Equifax® pour vous aider à suivre votre historique de crédit. Equifax® est une marque déposée d'Equifax Canada Co."
        }
      ]
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <section className="py-16 bg-amber-50 border-y border-amber-200">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-amber-900 mb-2">
              {text?.title}
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {text?.disclaimers?.map((disclaimer, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-lg p-6 border border-amber-200"
              >
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <Icon name={disclaimer?.icon} size={16} className="text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-amber-900 mb-2">
                      {disclaimer?.title}
                    </h3>
                    <p className="text-sm text-amber-800">
                      {disclaimer?.text}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DisclaimerSection;